<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @preRepair="preRepairFun"
        @preChange="preChangeFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.userName"
              placeholder="请输入用户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @exportPdf="exportPdfFun(arguments)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      :task-type="taskType"
      :dialog-title="dialogTitle"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import ViewDialog from './components/viewDialog'
// 待办列表
import taskListDialog from './components/taskListDialog'
// 数据请求
import { loadActivitySignInOutInfoListDataApi, loadActivitySignInOutInfoExportDataApi, findCountByConditionApi } from '@/api/activitySignInOutInfo'

export default {
  name: 'ActivitySignInOutInfo',
  components: {
    CustomTable,
    TableOperation,
    ViewDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'activity_sign_in_out_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['activity_sign_in_out_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['activity_sign_in_out_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            schemeNo: '',
            userName: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      // 待办
      todoList: [
        {
          permissionSigns: ['activity_sign_in_out_info_repair'],
          label: '待补签',
          method: 'preRepair',
          count: 0
        },
        {
          permissionSigns: ['activity_sign_in_out_info_change'],
          label: '待改签',
          method: 'preChange',
          count: 0
        }
      ],
      taskType: 0,
      dialogTitle: '',
      dialogTaskVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'validateWarning', filterColumn: 'i.validate_warning', label: '预警信息', width: 220 },
      { prop: 'provinceName', filterColumn: 's.province_names', label: '省区名称', width: 120 },
      { prop: 'cityName', filterColumn: 's.city_names', label: '城市名称', width: 120 },
      { prop: 'schemeName', filterColumn: 's.name', label: '方案名称', width: 220 },
      { prop: 'schemeNo', filterColumn: 's.project_no', label: '方案编号', width: 220 },
      { prop: 'sortStr', filterColumn: 'i.sort', filterValue: 'sort', label: '类型', width: 120, filterArray: [{ label: '活动报告', value: 1 }, { label: '工作日志', value: 2 }] },
      { prop: 'sellId', filterColumn: 'i.sell_id', label: '报告编号', width: 120 },
      { prop: 'logId', filterColumn: 'i.log_id', label: '日志编号', width: 120 },
      { prop: 'storeName', filterColumn: 'i.store_name', label: '活动场所', width: 120 },
      { prop: 'userName', filterColumn: 'i.user_name', label: '人员名称', width: 120 },
      { prop: 'activityDateStr', filterColumn: 'i.activity_date', label: '工作日期', width: 140, isBetween: true },
      { prop: 'activityTimeStr', label: '工作时间段', filterColumn: '(case activity_time when \'1,2\' then \'上午,下午\' when \'1,3\' then \'上午,晚上\' when \'2,3\' then \'下午,晚上\' when 1 then \'上午\' when 2 then \'下午\' when 3 then \'晚上\' else \'\' end)', width: 120 },
      { prop: 'fieldTypeStr', filterColumn: 'i.field_type', filterValue: 'fieldType', label: '活动场次', width: 120, filterArray: [{ label: '一场半天', value: 1 }, { label: '一场一天', value: 2 }] },
      { prop: 'isSignInStr', filterColumn: 'i.is_sign_in', filterValue: 'isSignIn', label: '是否签到', width: 120, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
      { prop: 'signInTimeStr', filterColumn: 'i.sign_in_time', label: '签到时间', width: 160 },
      { prop: 'signInAddress', filterColumn: 'i.sign_in_address', label: '签到地点', width: 160 },
      { prop: 'isSignOutStr', filterColumn: 'i.is_sign_out', filterValue: 'isSignIn', label: '是否签退', width: 120, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
      { prop: 'signOutTimeStr', filterColumn: 'i.sign_out_time', label: '签退时间', width: 160 },
      { prop: 'signOutAddress', filterColumn: 'i.sign_out_address', label: '签退地点', width: 160 },
      { prop: 'minuteDifference', filterColumn: 'i.minute_difference', label: '分钟时差', width: 120 },
      { prop: 'hourDifference', filterColumn: 'i.hour_difference', label: '小时时差', width: 120 },
      { prop: 'remark', filterColumn: 'i.remark', label: '备注' },
      { prop: 'creatorName', filterColumn: 'i.creator_name', label: '创建人', width: 150 },
      { prop: 'createTimeStr', filterColumn: 'i.create_time', label: '创建时间', width: 160, isBetween: true },
      { prop: 'operatorName', filterColumn: 'i.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'i.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadActivitySignInOutInfoListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      findCountByConditionApi({isRepair: 1}).then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
      findCountByConditionApi({isChange: 1}).then(res => {
        this.todoList[1].count = res.data ? res.data : 0
      })
    },
    preRepairFun () {
      this.taskType = 1
      this.dialogTitle = '待补签的签到签退信息'
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    preChangeFun () {
      this.taskType = 2
      this.dialogTitle = '待改签的签到签退信息'
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看活动工作日志'
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadActivitySignInOutInfoExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
